import { render, staticRenderFns } from "./CoverageItemAddModal.vue?vue&type=template&id=6f55ab02&scoped=true"
import script from "./CoverageItemAddModal.vue?vue&type=script&lang=js"
export * from "./CoverageItemAddModal.vue?vue&type=script&lang=js"
import style0 from "./CoverageItemAddModal.vue?vue&type=style&index=0&id=6f55ab02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f55ab02",
  null
  
)

export default component.exports